<template>
  <label :for="inputId" class="form-label">
    {{ labelText }}
  </label>
  <input
    :type="type"
    class="form-control"
    :id="inputId"
    :ref="inputId+'ref'"
    v-model="inputField"
    :pattern="pattern"
    :maxlength="maxlength"
    :placeholder="intl[$store.state.lang][inputId + '-placeholder'] || null"
    :required="isRequired"
  />

  <div :ref="inputId + 'ref-invalid-feedback'" :id="inputId + '-invalid-feedback'" class="invalid-feedback">
    <template v-if="customErrorLabelKey">
      {{ intl[$store.state.lang][customErrorLabelKey] }}
    </template>
    <template v-else>
      {{ intl[$store.state.lang][errorLabelKey] }}
    </template>
  </div>
</template>

<script>
import intl from "./intl/intl";

export default {
  name: "textInput",
  components: {},

  props: {
    inputId: {
      type: String,
      default: null,
    },
    pattern: {
      type: String,
      default: null,
    },
    errorLabelKey: {
      type: String,
      default: null,
    },
    labelKey: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },

    maxlength: {
      type: String,
      default: null,
    },
    linkedToOtherInput: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {},
  beforeUnmount() {},
  data: function () {
    return {
      intl: intl,
      inputField: "",
      customErrorLabelKey: "",
      isRequired: this.required
    };
  },
  methods: {
    setRequired(required){
      this.isRequired = required
    },
    setCustomErrorLabelKey(label){
      this.customErrorLabelKey = label
    },
    isNumber(){
      return !isNaN(Number(this.inputField));
    },
    removeInvalidClassFromInput() {
      const form = document.getElementById('ticket-form-create')
      if (form && form.classList.contains("was-validated")) {
        const inputElement =  this.$refs[this.inputId+"ref"] 
        const invalidFeedbackElement = this.$refs[this.inputId + 'ref-invalid-feedback'] 
        invalidFeedbackElement.style['visibility'] = 'hidden'
        invalidFeedbackElement.style['display'] = 'none'
        inputElement.style['background-repeat'] = 'no-repeat'
        inputElement.style['backgroundPosition'] = 'right calc(.375em + .1875rem) center'
        inputElement.style['borderColor'] = "#198754"
        inputElement.style['backgroundSize'] = "calc(.75em + .375rem) calc(.75em + .375rem)"
        inputElement.style['backgroundImage'] = "url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e')"
        //inputElement.style['boxShadow'] = '0 0 0 0.25rem  rgba(25, 135, 84, 0.25)'
        inputElement.addEventListener('focus', function() {
            this.style.boxShadow = '0 0 0 0.25rem rgba(25, 135, 84, 0.25)'; // Rosso (come il borderColor)
        });
        inputElement.addEventListener('blur', function() {
            this.style.boxShadow = 'none'; // Rimuove l'effetto quando perde il focus
        });
      }
     
    },
    addInvalidClassFromInput() {
      const inputElement =  this.$refs[this.inputId+"ref"] 
      const invalidFeedbackElement = this.$refs[this.inputId + 'ref-invalid-feedback']
      const form = document.getElementById('ticket-form-create')

      if (form && form.classList.contains("was-validated")) {
        invalidFeedbackElement.style['visibility'] = 'visible'
        invalidFeedbackElement.style['display'] = 'block'
        inputElement.style['background-repeat'] = 'no-repeat'
        inputElement.style['background-position'] = 'right calc(.375em + .1875rem) center'
        inputElement.style['borderColor'] = "#dc3545"
        inputElement.style['backgroundSize'] = "calc(.75em + .375rem) calc(.75em + .375rem)"
        inputElement.style['backgroundImage'] = "url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e')"
        //inputElement.style['boxShadow'] = '0 0 0 0.25rem rgba(220, 53, 69, 0.25)'
        inputElement.addEventListener('focus', function() {
            this.style.boxShadow = '0 0 0 0.25rem rgba(220, 53, 69, 0.25)'; // Rosso (come il borderColor)
        });
        inputElement.addEventListener('blur', function() {
            this.style.boxShadow = 'none'; // Rimuove l'effetto quando perde il focus
        });

      } 
         },
    requiredInputIsOk() {
      if (this.pattern) {
        //const regex = new RegExp(this.pattern, 'i');
        return document.getElementById(this.inputId).checkValidity();
      } else {
        if(!this.isRequired){
          return true
        }
        else if (this.isRequired && this.inputField !== "") {
          return true;
        }
      }
      return false
    },
  },
  watch: {
    
    inputField(newValue, oldValue) {
      if(newValue !== oldValue && newValue.length <= this.maxlength){
        this.$emit('textInput-changed', newValue, this.inputId);
      }else{
        this.inputField = oldValue
      }
      
    }
  },
  computed: {
    labelText: function () {
      if(this.linkedToOtherInput){
        return this.intl[this.$store.state.lang][this.labelKey] + "**:"
      }if (this.isRequired) {
        return this.intl[this.$store.state.lang][this.labelKey] + "*:";
      } else {
        return this.intl[this.$store.state.lang][this.labelKey] + ":";
      }
    },
  },
};
</script>
